import React from "react";

export default function TemplateModal({
  selectedTemplate,
  setSelectedTemplate,
  selectedPhone,
  activeContact,
  sending,
  onClose,
  onSendApprovedTemplate,
}) {
  return (
    <div className="v-modal-backdrop" onClick={onClose} role="dialog" aria-modal="true">
      <div className="v-modal-box" onClick={(e) => e.stopPropagation()}>
        <div className="v-modal-header">
          <div className="v-modal-title">
            <i className="bi bi-lightning-charge-fill text-warning me-2"></i>
            <span>Send Approved Meta Template</span>
          </div>
          <button type="button" className="v-btn-icon-close" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>

        <div className="v-modal-body">
          <p className="v-modal-subtitle">
            Meta Cloud API permits business-initiated messages outside the 24-hour window using pre-approved templates:
          </p>

          <div className="v-template-list">
            {/* Template 1: Expiry Reminder */}
            <label
              className={`v-template-card ${selectedTemplate === "vaithikasri_expiry_reminder" ? "active" : ""}`}
            >
              <input
                type="radio"
                name="tpl"
                value="vaithikasri_expiry_reminder"
                checked={selectedTemplate === "vaithikasri_expiry_reminder"}
                onChange={(e) => setSelectedTemplate(e.target.value)}
              />
              <div className="v-tpl-info">
                <span className="v-tpl-name">⏰ vaithikasri_expiry_reminder</span>
                <p className="v-tpl-desc">
                  "Namaskaram [Name], Your annual subscription [ID] will expire with the [Month] issue. Kindly renew to avoid missing future magazine copies."
                </p>
                <span className="v-tpl-badge">Category: Utility • Interactive Button</span>
              </div>
            </label>

            {/* Template 2: Renewal Success */}
            <label
              className={`v-template-card ${selectedTemplate === "vaithikasri_renewal_success" ? "active" : ""}`}
            >
              <input
                type="radio"
                name="tpl"
                value="vaithikasri_renewal_success"
                checked={selectedTemplate === "vaithikasri_renewal_success"}
                onChange={(e) => setSelectedTemplate(e.target.value)}
              />
              <div className="v-tpl-info">
                <span className="v-tpl-name">✨ vaithikasri_renewal_success</span>
                <p className="v-tpl-desc">
                  "Namaskaram [Name], Your VaithikaSri subscription has been successfully renewed! Valid Till: [Month]. Receipt attached."
                </p>
                <span className="v-tpl-badge">Category: Utility • PDF Receipt Header</span>
              </div>
            </label>

            {/* Template 3: New Subscription */}
            <label
              className={`v-template-card ${selectedTemplate === "vaithikasri_new_subscription" ? "active" : ""}`}
            >
              <input
                type="radio"
                name="tpl"
                value="vaithikasri_new_subscription"
                checked={selectedTemplate === "vaithikasri_new_subscription"}
                onChange={(e) => setSelectedTemplate(e.target.value)}
              />
              <div className="v-tpl-info">
                <span className="v-tpl-name">📜 vaithikasri_new_subscription</span>
                <p className="v-tpl-desc">
                  "Namaskaram [Name], Welcome to VaithikaSri Spiritual Magazine. Your Subscription ID is [ID]. Your monthly issue will arrive soon."
                </p>
                <span className="v-tpl-badge">Category: Utility • Welcome Receipt</span>
              </div>
            </label>

            {/* Template 4: Monthly Dispatch Alert */}
            <label
              className={`v-template-card ${selectedTemplate === "vaithikasri_monthly_dispatch_alert" ? "active" : ""}`}
            >
              <input
                type="radio"
                name="tpl"
                value="vaithikasri_monthly_dispatch_alert"
                checked={selectedTemplate === "vaithikasri_monthly_dispatch_alert"}
                onChange={(e) => setSelectedTemplate(e.target.value)}
              />
              <div className="v-tpl-info">
                <span className="v-tpl-name">📦 vaithikasri_monthly_dispatch_alert</span>
                <p className="v-tpl-desc">
                  "பிரதி மாதம் போல் இந்த [Month] மாத புஸ்தகம் சந்தாதாரர்கள் அனைவருக்கும் தபால் மூலம் அனுப்பி வைக்கப்பட்டுள்ளது."
                </p>
                <span className="v-tpl-badge">Category: Utility • Tamil Dispatch Notice</span>
              </div>
            </label>
          </div>

          <div className="v-recipient-notice">
            <i className="bi bi-person-check me-1"></i>
            <span>Target Recipient: <strong>+{selectedPhone}</strong> ({activeContact.name || "Customer"})</span>
          </div>
        </div>

        <div className="v-modal-footer">
          <button
            type="button"
            className="btn btn-sm btn-secondary"
            onClick={onClose}
            disabled={sending}
          >
            Cancel
          </button>
          <button
            type="button"
            className="v-btn-primary"
            onClick={onSendApprovedTemplate}
            disabled={sending}
          >
            {sending ? (
              <>
                <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                <span>Triggering Meta Template...</span>
              </>
            ) : (
              <>
                <i className="bi bi-send-check-fill me-1"></i>
                <span>Send Template Now</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
